import React from "react";

export default function Layout({ children }) {
  return <div className="wrapper">{children}</div>;
}
